import { render, staticRenderFns } from "./Addons.vue?vue&type=template&id=d9ff0d00"
import script from "./Addons.vue?vue&type=script&lang=js"
export * from "./Addons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports